import clsx from 'clsx';
import { Component } from '@headless-workspace/typings';
import { PropsWithClassName } from '../../props';

export enum DividerDirection {
    Vertical = 'vertical',
    Horizontal = 'horizontal',
}

export type GlowDividerProps = PropsWithClassName & {
    direction?: DividerDirection;
};

export const GlowDivider: Component<GlowDividerProps> = ({ className, direction = DividerDirection.Horizontal }) => {
    if (direction === DividerDirection.Vertical) {
        return <div className={clsx('h-screen w-divider bg-border-primary', className)} />;
    }

    return (
        <hr className={clsx('w-full border-t border-t-medium border-t-border-primary bg-border-primary', className)} />
    );
};
